import * as Types from "../../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddOrganisationMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  short_name: Types.Scalars["String"];
  demo_dashboard?: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type AddOrganisationMutation = { __typename?: "mutation_root" } & {
  insert_organisations_one?: Types.Maybe<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "name" | "short_name"
    >
  >;
};

export const AddOrganisationDocument = gql`
  mutation AddOrganisation(
    $name: String!
    $short_name: String!
    $demo_dashboard: Boolean = true
  ) {
    insert_organisations_one(
      object: {
        name: $name
        short_name: $short_name
        demo_dashboard: $demo_dashboard
      }
    ) {
      id
      name
      short_name
    }
  }
`;

export function useAddOrganisationMutation() {
  return Urql.useMutation<
    AddOrganisationMutation,
    AddOrganisationMutationVariables
  >(AddOrganisationDocument);
}
